/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'security';
const componentName = 'certificate-chain-dialog';
const prefix = `${moduleName}.${componentName}`;

export const certificateChainTitle = `${prefix}.certificateChainTitle`;
export const closeButtonLabel = `${prefix}.closeButtonLabel`;

export const ENGLISH = {
    [certificateChainTitle]: 'Certificate Chain',
    [closeButtonLabel]: 'CLOSE',
};
